import { LitElement, html, css } from 'lit'
import {unsafeHTML} from 'lit/directives/unsafe-html.js'
import Panel from 'bui/presenters/panel'
import Dialog from 'bui/presenters/dialog'
import 'bui/elements/sub'

customElements.defineShared('steens-medical-form', class extends LitElement{

    static get styles(){return css`
        :host {
            --fc-theme: var(--green);
            display: grid;
            grid-template-rows: auto 1fr;
            position:relative;
            overflow: hidden;
        }

        b-panel-toolbar,
        radio-btn {
            font-family: var(--font-header);
        }

        radio-btn {
            --labelSize: .8em;
            --radio-btn-label-padding: -1em;
        }

        form-handler {
            overflow: auto;
        }

        .question {
            padding: .5em 1em .5em .5em;
            column-gap: 1em;
            display: grid;
            grid-template-columns: 1fr auto;
            align-items: center;
            border-bottom: solid 1px rgba(0,0,0,.1);
        }

        form-control {
            grid-column: 1/-1;
        }

        radio-group[desired="0"]:not([value="1"]) ~ form-control,
        radio-group[desired="1"]:not([value="0"]) ~ form-control {
            display: none;
        }

        form-handler > b-btn {
            margin: 1em;
        }

        [mustbe="1"] [value="0"][active],
        [mustbe="0"] [value="1"][active] {
            --color: var(--red);
        }
    `}
    
    get coll(){
        return this.model?.get('medform')
    }

    render(){return html`
        <b-panel-toolbar></b-panel-toolbar>

        <form-handler store="med-history">
        ${this.coll?.map((m,i)=>html`
            <div class="question">
                
                <div>
                    <b-sub>${i+1}</b-sub> 
                    ${unsafeHTML(m.get('question').replace(/\n/g, '<br>'))}
                </div>

                <radio-group key="${m.get('id')}-val" desired="${m.get('desired')}" mustbe="${m.get('must_be')?m.get('desired'):''}">
                    <radio-btn value="0" placement="bottom" label="No"></radio-btn>
                    <radio-btn value="1" placement="bottom" label="Yes"></radio-btn>
                </radio-group>

                ${m.get('needs_comment') ? html`
                <form-control material="filled" key="${m.get('id')}-comment">
                    <text-field required placeholder="Please explain"></text-field>
                </form-control>
                `:''}

            </div>
        `)}
        

        <b-btn block color="primary" pill @click=${this.close}>Done</b-btn>

        </form-handler>
    `}

    get results(){

        let values = this.shadowRoot.querySelectorAll("[key]")

        values.forEach(el=>{
            let key = el.getAttribute('key')
            let [id, k] = key.split('-')
            // data[id][k] = el.value

            this.coll.get(id).set(k, el.value)
        })

        return this.coll
    }

    clear(){
        localStorage.removeItem('med-history')
        if( this.coll )
            this.coll.forEach(m=>{
                m.set({
                    val: '',
                    comment: ''
                })
            })
        this.formHandler.resetValues()
        this.update()
    }

    async onClose(){

        let res = this.results

        if( res.numComplete > 0 && !res.isComplete
        && !await Dialog.confirm({
            title: `Incomplete`,
            msg: 'You will need to finish this before submitting registration'
        }).modal() )
            return false
    }

    close(){
        this.panel.close()
    }

    open(model, result){

        this.model = model
        this.result = result

        this.panel = this.panel || new Panel(this, {
            title: 'Medical History',
            width: '600px',
            // height: '600px',
            anchor: 'center',
            quickJump: false,
            disableBackdropClick: true,
            // onClose: this.onClose.bind(this, btn)
        })

        this.panel.open()

        window.mf = this // TEMP
    }

})


export default customElements.get('steens-medical-form')